export default __webpack_public_path__ + "static/media/2.464f93e0.jpg";